import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { jwtDecode } from "jwt-decode";
import { useNavigate } from 'react-router-dom';
import Loader from '../Loader';
import MemberVerificationPopup from './MemberVerification'



const Staking = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [staking, setStaking] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const baseUrl = process.env.REACT_APP_API;


  const invoiceId = "8kBQC2uXDJzjsvc8gfNcX5aEPWHw44jPK"; 
  const [memberCode, setmemberCode] = useState(null);

   const [isVerified, setIsVerified] = useState({
  email: false,
  wallet: false
});

    useEffect(() => {
        const token = sessionStorage.getItem('authToken');
        if (!token) {
          navigate('/token/signin');
          return;
        }
      
        const validateToken = async () => {
          try {
            const response = await fetch(`${baseUrl}/validate-token`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({ token }),
            });
      
            const data = await response.json();
      
            if (!data.valid) {
              sessionStorage.removeItem('authToken'); // Optional cleanup
              navigate('/token/signin');
            }
          } catch (error) {
            console.error('Token validation failed:', error);
            sessionStorage.removeItem('authToken');
            navigate('/token/signin');
          }
        };
      
        validateToken();
      }, [navigate]);

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");

    if (token) {
      try {
        const decoded = jwtDecode(token);
        setmemberCode(decoded.memberCode );
      } catch (error) {
        console.error("Invalid token", error);
      }
    }
  }, []);

  // Fetch staking data from the API
  useEffect(() => {

    const fetchStaking = async () => {
      if (!memberCode) return;
      setLoading(true);
      const token = sessionStorage.getItem("authToken");
      try {
        const response = await axios.get(`${baseUrl}/api/staking/${memberCode}`, {
          headers: {
            'Content-Type': 'application/json',
             Authorization: `Bearer ${token}`,
          }
        });

        if (response.data && response.data.staking) {
          setStaking(response.data.staking.reverse());
        }
    } catch (error) {
        console.error('Error fetching staking:', error);
      } finally {
        setLoading(false); // End loading
      }
    };

    fetchStaking();
}, [memberCode, invoiceId]); 

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Paginated data
  const indexOfLastTransaction = currentPage * itemsPerPage;
  const indexOfFirstTransaction = indexOfLastTransaction - itemsPerPage;
  const currentstaking = staking.slice(indexOfFirstTransaction, indexOfLastTransaction);


  const getSerialNumber = (index) => index + indexOfFirstTransaction + 1;
  if (loading) {
    return (
      <div className="loader-wrapper">
        <Loader />
      </div>
    );
  }

    const handleVerificationChange = (verificationData) => {
  setIsVerified({
    email: verificationData.IsEmailVerified === 1,
    wallet: !!verificationData.PhantomSolanaAddress
  });
};

  return (

    <>
    <MemberVerificationPopup 
      memberCode={memberCode} 
      onVerificationChange={handleVerificationChange} 
    />
      <div
        style={{
          backgroundImage: `url(/images/main-background.jpg)`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          minHeight: '100vh',
          width: '100%',
          position: 'absolute',
          top: 0,
          left: 0,
          zIndex: -1,
          filter: 'blur(10px)',
        }}
      ></div>
    <div className="transactions-wrapper">
    <div className="transactions-container">
  <h6>
    <strong>Staking Summary</strong>
  </h6>

  {/* Conditional rendering based on transaction availability */}
  {staking.length === 0 ? (
      <div className="no-transactions-message">
      <p>No Staking Summary</p>
    </div>
  ) : (
    <>
      {/* Table to display staking */}
      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              <th>#</th>
              <th>Amount (RZTO)</th>
              <th>Rewards</th>
              <th>Lock Days</th>
              <th>Status</th>
              <th>Stake Time</th>
              <th>Unlock Time</th>
              <th>Transaction Hash</th>
            </tr>
          </thead>
          <tbody>
            {currentstaking.map((transaction, index) => (
              <tr key={transaction.StakingID}>
                <td>{getSerialNumber(index)}</td>
                <td>{transaction.Amount}</td>
                <td>{transaction.Rewards}</td>
                <td>{transaction.LockDays}</td>
                <td>{transaction.Status}</td>
                <td>{new Date(transaction.StakeTimestamp).toLocaleString()}</td>
                <td>{new Date(transaction.UnlockTimestamp).toLocaleString()}</td>
                <td style={{ wordBreak: 'break-all' }}>{transaction.TransactionReference}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination Controls */}
      <div className="pagination">
        <button
          disabled={currentPage === 1}
          onClick={() => handlePageChange(currentPage - 1)}
        >
          Previous
        </button>
        <span>Page {currentPage}</span>
        <button
          disabled={currentPage === Math.ceil(staking.length / itemsPerPage)}
          onClick={() => handlePageChange(currentPage + 1)}
        >
          Next
        </button>
      </div>
    </>
  )}
</div>

    </div>
    </>
  );
};

export default Staking;

// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { jwtDecode } from "jwt-decode";
// import { useNavigate } from 'react-router-dom';
// import Loader from '../Loader';
// import MemberVerificationPopup from './MemberVerification'
// import { useWallet } from '@solana/wallet-adapter-react';
// import { Connection, Transaction } from '@solana/web3.js';




// const Staking = () => {
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(true);
//   const [staking, setStaking] = useState([]);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;

//   const baseUrl = process.env.REACT_APP_API;


//   const invoiceId = "8kBQC2uXDJzjsvc8gfNcX5aEPWHw44jPK"; 
//   const [memberCode, setmemberCode] = useState(null);

//    const [isVerified, setIsVerified] = useState({
//    email: false,
//    wallet: false
//    });

//     useEffect(() => {
//         const token = sessionStorage.getItem('authToken');
//         if (!token) {
//           navigate('/token/signin');
//           return;
//         }
      
//         const validateToken = async () => {
//           try {
//             const response = await fetch(`${baseUrl}/validate-token`, {
//               method: 'POST',
//               headers: {
//                 'Content-Type': 'application/json',
//               },
//               body: JSON.stringify({ token }),
//             });
      
//             const data = await response.json();
      
//             if (!data.valid) {
//               sessionStorage.removeItem('authToken'); // Optional cleanup
//               navigate('/token/signin');
//             }
//           } catch (error) {
//             console.error('Token validation failed:', error);
//             sessionStorage.removeItem('authToken');
//             navigate('/token/signin');
//           }
//         };
      
//         validateToken();
//       }, [navigate]);

//   useEffect(() => {
//     const token = sessionStorage.getItem("authToken");

//     if (token) {
//       try {
//         const decoded = jwtDecode(token);
//         setmemberCode(decoded.memberCode );
//       } catch (error) {
//         console.error("Invalid token", error);
//       }
//     }
//   }, []);

//   // Fetch staking data from the API
//   useEffect(() => {

//     const fetchStaking = async () => {
//       if (!memberCode) return;
//       setLoading(true);
//       const token = sessionStorage.getItem("authToken");
//       try {
//         const response = await axios.get(`${baseUrl}/api/staking/${memberCode}`, {
//           headers: {
//             'Content-Type': 'application/json',
//              Authorization: `Bearer ${token}`,
//           }
//         });

//         if (response.data && response.data.staking) {
//           setStaking(response.data.staking.reverse());
//         }
//     } catch (error) {
//         console.error('Error fetching staking:', error);
//       } finally {
//         setLoading(false); // End loading
//       }
//     };

//     fetchStaking();
// }, [memberCode, invoiceId]); 

//   // Handle page change
//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   // Paginated data
//   const indexOfLastTransaction = currentPage * itemsPerPage;
//   const indexOfFirstTransaction = indexOfLastTransaction - itemsPerPage;
//   const currentstaking = staking.slice(indexOfFirstTransaction, indexOfLastTransaction);


//   const getSerialNumber = (index) => index + indexOfFirstTransaction + 1;
//   if (loading) {
//     return (
//       <div className="loader-wrapper">
//         <Loader />
//       </div>
//     );
//   }

//     const handleVerificationChange = (verificationData) => {
//   setIsVerified({
//     email: verificationData.IsEmailVerified === 1,
//     wallet: !!verificationData.PhantomSolanaAddress
//   });
// };


// const handleClaim = async () => {
//   try {
//     const connection = new Connection('https://api.mainnet-beta.solana.com'); 
//     const wallet = window.solana;

//     if (!wallet || !wallet.publicKey) {
//       alert("Wallet not connected");
//       return;
//     }

//     const userPublicKey = wallet.publicKey.toString();

//     // Step 1: Get unsigned transaction from backend
//     const claimResponse = await axios.post(`${baseUrl}/api/claim`, { userPublicKey });

//     if (!claimResponse.data.success) {
//       alert("Failed to generate claim transaction");
//       return;
//     }

//     const { tx, blockhash, lastValidBlockHeight } = claimResponse.data;

//     // Step 2: Decode and sign the transaction
//     const txBuffer = Buffer.from(tx, 'base64');
//     const transaction = Transaction.from(txBuffer);
//     transaction.recentBlockhash = blockhash;
//     transaction.feePayer = wallet.publicKey;

//     const signedTx = await wallet.signTransaction(transaction);

//     // Step 3: Send signed transaction to backend
//     const confirmResponse = await axios.post(`${baseUrl}/api/confirmTransaction`, {
//       signedTx: signedTx.serialize().toString('base64'),
//       metadata: {
//         type: 'claim',
//         memberCode: memberCode // if available
//       }
//     });

//     if (confirmResponse.data.success) {
//       alert("Claim successful!");
//     } else {
//       alert("Claim failed. Please try again.");
//     }

//   } catch (error) {
//     console.error("Error claiming rewards:", error);
//     alert("An error occurred during the claim process.");
//   }
// };


//   return (

//     <>
//          <MemberVerificationPopup 
//       memberCode={memberCode} 
//       onVerificationChange={handleVerificationChange} 
//     />
//       <div
//         style={{
//           backgroundImage: `url(/images/main-background.jpg)`,
//           backgroundSize: 'cover',
//           backgroundPosition: 'center',
//           minHeight: '100vh',
//           width: '100%',
//           position: 'absolute',
//           top: 0,
//           left: 0,
//           zIndex: -1,
//           filter: 'blur(10px)',
//         }}
//       ></div>
//     <div className="transactions-wrapper">
//     <div className="transactions-container">
//   <h6>
//     <strong>Staking Summary</strong>
//   </h6>
//   <button onClick={handleClaim} className="btn btn-primary">
//   Claim Rewards
// </button>

//   {/* Conditional rendering based on transaction availability */}
//   {staking.length === 0 ? (
//       <div className="no-transactions-message">
//       <p>No Staking Summary</p>
//     </div>
//   ) : (
//     <>
//       {/* Table to display staking */}
//       <div className="table-container">
//         <table className="table">
//           <thead>
//             <tr>
//               <th>#</th>
//               <th>Amount (RZTO)</th>
//               <th>Rewards</th>
//               <th>Lock Days</th>
//               <th>Status</th>
//               <th>Stake Time</th>
//               <th>Unlock Time</th>
//               <th>Transaction Hash</th>
//             </tr>
//           </thead>
//           <tbody>
//             {currentstaking.map((transaction, index) => (
//               <tr key={transaction.StakingID}>
//                 <td>{getSerialNumber(index)}</td>
//                 <td>{transaction.Amount}</td>
//                 <td>{transaction.Rewards}</td>
//                 <td>{transaction.LockDays}</td>
//                 <td>{transaction.Status}</td>
//                 <td>{new Date(transaction.StakeTimestamp).toLocaleString()}</td>
//                 <td>{new Date(transaction.UnlockTimestamp).toLocaleString()}</td>
//                 <td style={{ wordBreak: 'break-all' }}>{transaction.TransactionReference}</td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination Controls */}
//       <div className="pagination">
//         <button
//           disabled={currentPage === 1}
//           onClick={() => handlePageChange(currentPage - 1)}
//         >
//           Previous
//         </button>
//         <span>Page {currentPage}</span>
//         <button
//           disabled={currentPage === Math.ceil(staking.length / itemsPerPage)}
//           onClick={() => handlePageChange(currentPage + 1)}
//         >
//           Next
//         </button>
//       </div>
//     </>
//   )}
// </div>

//     </div>
//     </>
//   );
// };

// export default Staking;
